
export const floor = Math['floor'];
export const ceil = Math['ceil'];
export const between = (v: number, min: number, max: number) => v >= min && v <= max;
export const abs = Math['abs'];
export const max = Math['max'];
export const min = Math['min'];
export const round = Math['round'];
export const sqrt = Math['sqrt'];
export const cos = Math['cos'];
export const sin = Math['sin'];
export const acos = Math['acos'];
export const pow = Math['pow'];
export const sign = Math['sign'];
export const tan = Math['tan'];
export const PI = Math['PI'];
